<div class="space-y-8 animate-fade-in-up font-sans">

  <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 relative overflow-hidden">
    <div class="absolute left-0 top-0 bottom-0 w-1 bg-[#1e3a8a]"></div>

    <div class="flex items-center gap-4">
      <div class="bg-blue-50 p-3 rounded-xl text-[#1e3a8a] shadow-inner">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
      </div>
      <div>
        <h2 class="text-2xl font-black text-[#1e3a8a] tracking-wide uppercase">Resumen Financiero</h2>
        <p class="text-xs text-gray-500 font-medium mt-1">Control de flujo de caja y facturación</p>
      </div>
    </div>

    <div class="flex flex-wrap gap-3 w-full md:w-auto">
      <button class="flex-1 md:flex-none flex items-center justify-center gap-2 bg-white border border-gray-200 text-gray-700 px-5 py-2.5 rounded-xl shadow-sm hover:bg-gray-50 hover:border-gray-300 transition-all text-sm font-bold group">
        <svg class="w-4 h-4 text-gray-400 group-hover:text-[#1e3a8a]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"></path></svg>
        Descargar Reporte
      </button>
      <button class="flex-1 md:flex-none flex items-center justify-center gap-2 bg-[#1e3a8a] hover:bg-[#ffb31c] text-white hover:text-[#1e3a8a] px-5 py-2.5 rounded-xl shadow-md transition-all text-sm font-bold group">
        <svg class="w-4 h-4 transform group-hover:rotate-90 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path></svg>
        Nueva Factura
      </button>
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">

    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 relative overflow-hidden group hover:shadow-md transition-shadow">
      <div class="absolute right-0 top-0 w-2 h-full bg-[#1e3a8a]"></div>
      <svg class="absolute -right-4 -bottom-4 w-24 h-24 text-gray-50 opacity-50 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path></svg>
      <div class="relative z-10">
        <p class="text-[10px] text-gray-500 font-bold uppercase tracking-widest mb-2">Total Facturado (YTD)</p>
        <h3 class="text-3xl font-black text-gray-800 tracking-tight">{{ totalFacturado | currency:'USD':'symbol':'1.0-0' }}</h3>
        <p class="text-xs text-green-600 font-bold mt-2 flex items-center gap-1">
          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path></svg>
          12.5% vs año anterior
        </p>
      </div>
    </div>

    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 relative overflow-hidden group hover:shadow-md transition-shadow">
      <div class="absolute right-0 top-0 w-2 h-full bg-[#ffb31c]"></div>
      <svg class="absolute -right-4 -bottom-4 w-24 h-24 text-gray-50 opacity-50 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"></path></svg>
      <div class="relative z-10">
        <p class="text-[10px] text-gray-500 font-bold uppercase tracking-widest mb-2">Cuentas por Cobrar</p>
        <h3 class="text-3xl font-black text-gray-800 tracking-tight">{{ porCobrar | currency:'USD':'symbol':'1.0-0' }}</h3>
        <p class="text-xs text-yellow-600 font-bold mt-2 flex items-center gap-1">
          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
          Esperando pago
        </p>
      </div>
    </div>

    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 relative overflow-hidden group hover:shadow-md transition-shadow">
      <div class="absolute right-0 top-0 w-2 h-full bg-red-500"></div>
      <svg class="absolute -right-4 -bottom-4 w-24 h-24 text-gray-50 opacity-50 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 0l-2 2a1 1 0 101.414 1.414L8 10.414l1.293 1.293a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
      <div class="relative z-10">
        <p class="text-[10px] text-gray-500 font-bold uppercase tracking-widest mb-2">Total Egresos</p>
        <h3 class="text-3xl font-black text-gray-800 tracking-tight">{{ totalEgresos | currency:'USD':'symbol':'1.0-0' }}</h3>
        <p class="text-xs text-red-500 font-bold mt-2 flex items-center gap-1">
          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path></svg>
          4.2% vs mes anterior
        </p>
      </div>
    </div>

    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 relative overflow-hidden group hover:shadow-md transition-shadow">
      <div class="absolute right-0 top-0 w-2 h-full bg-green-500"></div>
      <svg class="absolute -right-4 -bottom-4 w-24 h-24 text-gray-50 opacity-50 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clip-rule="evenodd"></path></svg>
      <div class="relative z-10">
        <p class="text-[10px] text-gray-500 font-bold uppercase tracking-widest mb-2">Margen de Utilidad</p>
        <h3 class="text-3xl font-black text-green-600 tracking-tight">{{ margenUtilidad }}</h3>
        <p class="text-xs text-gray-400 font-bold mt-2 flex items-center gap-1">
          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
          Saludable
        </p>
      </div>
    </div>
  </div>

  <div class="grid grid-cols-1 xl:grid-cols-3 gap-6">

    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 xl:col-span-2 flex flex-col min-h-[450px]">
      <div class="flex justify-between items-center mb-6">
        <h3 class="text-sm font-black text-[#1e3a8a] uppercase tracking-wide">Flujo de Caja (Últimos 6 meses)</h3>
        <select class="border border-gray-200 bg-gray-50 text-gray-700 py-1.5 px-3 rounded-lg text-xs outline-none focus:ring-2 focus:ring-[#ffb31c] transition-all font-bold cursor-pointer">
          <option>2026</option>
          <option>2025</option>
        </select>
      </div>
      <div class="flex-1 relative">
        <canvas canvasStyle="width: 100%; height: 100%;" baseChart
          [data]="flujoCajaData"
          [options]="flujoCajaOptions"
          [type]="'bar'">
        </canvas>
      </div>
    </div>

    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 xl:col-span-1 overflow-hidden flex flex-col h-[450px]">

      <div class="p-5 border-b border-gray-100 bg-gray-50 flex justify-between items-center">
        <h3 class="text-sm font-black text-[#1e3a8a] uppercase tracking-wide">Facturas Recientes</h3>
        <span class="bg-blue-100 text-[#1e3a8a] py-0.5 px-2 rounded-full text-[10px] font-bold">{{ facturas.length }}</span>
      </div>

      <div class="overflow-y-auto flex-1 p-5 custom-scrollbar">
        <div class="space-y-4">
          @for (f of facturas; track f.numero) {
            <div class="group flex justify-between items-center p-4 border border-gray-100 rounded-xl hover:shadow-md hover:border-[#1e3a8a]/30 transition-all cursor-pointer bg-white">

              <div class="flex flex-col">
                <div class="flex items-center gap-2 mb-1">
                  <span class="text-xs font-black text-[#1e3a8a] bg-blue-50 px-2 py-0.5 rounded">{{ f.numero }}</span>
                </div>
                <p class="text-sm text-gray-800 font-bold group-hover:text-[#1e3a8a] transition-colors">{{ f.cliente }}</p>
                <p class="text-xs text-gray-400 font-medium flex items-center gap-1 mt-1">
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                  {{ f.fechaEmision | date:'dd MMM, yyyy' }}
                </p>
              </div>

              <div class="flex flex-col items-end justify-center">
                <p class="text-sm font-black text-gray-800">{{ f.monto | currency:'USD':'symbol':'1.0-0' }}</p>
                <span class="text-[9px] font-black uppercase px-2 py-1 rounded shadow-sm border mt-1"
                      [class.bg-green-50]="f.estado === 'Pagada'" [class.text-green-700]="f.estado === 'Pagada'" [class.border-green-200]="f.estado === 'Pagada'"
                      [class.bg-yellow-50]="f.estado === 'Pendiente'" [class.text-yellow-700]="f.estado === 'Pendiente'" [class.border-yellow-200]="f.estado === 'Pendiente'"
                      [class.bg-red-50]="f.estado === 'Vencida'" [class.text-red-700]="f.estado === 'Vencida'" [class.border-red-200]="f.estado === 'Vencida'">
                  {{ f.estado }}
                </span>
              </div>

            </div>
          }
        </div>
      </div>

      <div class="p-4 border-t border-gray-100 bg-gray-50 text-center hover:bg-gray-100 transition-colors cursor-pointer">
        <button class="text-xs font-bold text-[#1e3a8a] hover:text-[#ffb31c] transition-colors flex items-center justify-center gap-2 w-full">
          Ver todas las facturas
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
        </button>
      </div>

    </div>
  </div>
</div>
